import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2ca44885")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Registro de actividad", -1)
const _hoisted_2 = {
  class: "box",
  style: {"width":"50%"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Fecha de Kick-Off", -1)
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Activity = _resolveComponent("Activity")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_Calendar, {
            id: "dateKickOff",
            class: "box-size",
            autocomplete: "off",
            placeholder: 'DD/MM/YYYY',
            modelValue: _ctx.kickOffDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.kickOffDate = $event)),
            modelModifiers: { lazy: true },
            onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeKickOff()))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Activity, { tracing: _ctx.teacherActivity }, null, 8, ["tracing"])
        ]))
  ]))
}